export const pluralRulesDataByCode = {
  cs: () => import(
  // @ts-expect-error
  /* webpackChunkName: 'locale-data-cs' */
  '@formatjs/intl-pluralrules/dist/locale-data/cs'),
  da: () => import(
  // @ts-expect-error
  /* webpackChunkName: 'locale-data-da' */
  '@formatjs/intl-pluralrules/dist/locale-data/da'),
  de: () => import(
  // @ts-expect-error
  /* webpackChunkName: 'locale-data-de' */
  '@formatjs/intl-pluralrules/dist/locale-data/de'),
  en: () => import(
  // @ts-expect-error
  /* webpackChunkName: 'locale-data-en' */
  '@formatjs/intl-pluralrules/dist/locale-data/en'),
  es: () => import(
  // @ts-expect-error
  /* webpackChunkName: 'locale-data-es' */
  '@formatjs/intl-pluralrules/dist/locale-data/es'),
  fi: () => import(
  // @ts-expect-error
  /* webpackChunkName: 'locale-data-fi' */
  '@formatjs/intl-pluralrules/dist/locale-data/fi'),
  fr: () => import(
  // @ts-expect-error
  /* webpackChunkName: 'locale-data-fr' */
  '@formatjs/intl-pluralrules/dist/locale-data/fr'),
  hi: () => import(
  // @ts-expect-error
  /* webpackChunkName: 'locale-data-hi' */
  '@formatjs/intl-pluralrules/dist/locale-data/hi'),
  id: () => import(
  // @ts-expect-error
  /* webpackChunkName: 'locale-data-id' */
  '@formatjs/intl-pluralrules/dist/locale-data/id'),
  it: () => import(
  // @ts-expect-error
  /* webpackChunkName: 'locale-data-it' */
  '@formatjs/intl-pluralrules/dist/locale-data/it'),
  ja: () => import(
  // @ts-expect-error
  /* webpackChunkName: 'locale-data-ja' */
  '@formatjs/intl-pluralrules/dist/locale-data/ja'),
  ko: () => import(
  // @ts-expect-error
  /* webpackChunkName: 'locale-data-ko' */
  '@formatjs/intl-pluralrules/dist/locale-data/ko'),
  nl: () => import(
  // @ts-expect-error
  /* webpackChunkName: 'locale-data-nl' */
  '@formatjs/intl-pluralrules/dist/locale-data/nl'),
  pl: () => import(
  // @ts-expect-error
  /* webpackChunkName: 'locale-data-pl' */
  '@formatjs/intl-pluralrules/dist/locale-data/pl'),
  pt: () => import(
  // @ts-expect-error
  /* webpackChunkName: 'locale-data-pt' */
  '@formatjs/intl-pluralrules/dist/locale-data/pt'),
  ru: () => import(
  // @ts-expect-error
  /* webpackChunkName: 'locale-data-ru' */
  '@formatjs/intl-pluralrules/dist/locale-data/ru'),
  sv: () => import(
  // @ts-expect-error
  /* webpackChunkName: 'locale-data-sv' */
  '@formatjs/intl-pluralrules/dist/locale-data/sv'),
  th: () => import(
  // @ts-expect-error
  /* webpackChunkName: 'locale-data-th' */
  '@formatjs/intl-pluralrules/dist/locale-data/th'),
  tr: () => import(
  // @ts-expect-error
  /* webpackChunkName: 'locale-data-tr' */
  '@formatjs/intl-pluralrules/dist/locale-data/tr'),
  uk: () => import(
  // @ts-expect-error
  /* webpackChunkName: 'locale-data-uk' */
  '@formatjs/intl-pluralrules/dist/locale-data/uk'),
  vi: () => import(
  // @ts-expect-error
  /* webpackChunkName: 'locale-data-vi' */
  '@formatjs/intl-pluralrules/dist/locale-data/vi'),
  zh: () => import(
  // @ts-expect-error
  /* webpackChunkName: 'locale-data-zh' */
  '@formatjs/intl-pluralrules/dist/locale-data/zh'),
  nb: () => import(
  // @ts-expect-error
  /* webpackChunkName: 'locale-data-nb' */
  '@formatjs/intl-pluralrules/dist/locale-data/nb')
};
export const listFormatDataByCode = {
  cs: () => import( /* webpackChunkName: 'locale-data-cs' */'@formatjs/intl-listformat/locale-data/cs'),
  da: () => import( /* webpackChunkName: 'locale-data-da' */'@formatjs/intl-listformat/locale-data/da'),
  de: () => import( /* webpackChunkName: 'locale-data-de' */'@formatjs/intl-listformat/locale-data/de'),
  en: () => import( /* webpackChunkName: 'locale-data-en' */'@formatjs/intl-listformat/locale-data/en'),
  es: () => import( /* webpackChunkName: 'locale-data-es' */'@formatjs/intl-listformat/locale-data/es'),
  fi: () => import( /* webpackChunkName: 'locale-data-fi' */'@formatjs/intl-listformat/locale-data/fi'),
  fr: () => import( /* webpackChunkName: 'locale-data-fr' */'@formatjs/intl-listformat/locale-data/fr'),
  hi: () => import( /* webpackChunkName: 'locale-data-hi' */'@formatjs/intl-listformat/locale-data/hi'),
  id: () => import( /* webpackChunkName: 'locale-data-id' */'@formatjs/intl-listformat/locale-data/id'),
  it: () => import( /* webpackChunkName: 'locale-data-it' */'@formatjs/intl-listformat/locale-data/it'),
  ja: () => import( /* webpackChunkName: 'locale-data-ja' */'@formatjs/intl-listformat/locale-data/ja'),
  ko: () => import( /* webpackChunkName: 'locale-data-ko' */'@formatjs/intl-listformat/locale-data/ko'),
  nl: () => import( /* webpackChunkName: 'locale-data-nl' */'@formatjs/intl-listformat/locale-data/nl'),
  pl: () => import( /* webpackChunkName: 'locale-data-pl' */'@formatjs/intl-listformat/locale-data/pl'),
  pt: () => import( /* webpackChunkName: 'locale-data-pt' */'@formatjs/intl-listformat/locale-data/pt'),
  ru: () => import( /* webpackChunkName: 'locale-data-ru' */'@formatjs/intl-listformat/locale-data/ru'),
  sv: () => import( /* webpackChunkName: 'locale-data-sv' */'@formatjs/intl-listformat/locale-data/sv'),
  th: () => import( /* webpackChunkName: 'locale-data-th' */'@formatjs/intl-listformat/locale-data/th'),
  tr: () => import( /* webpackChunkName: 'locale-data-tr' */'@formatjs/intl-listformat/locale-data/tr'),
  uk: () => import( /* webpackChunkName: 'locale-data-uk' */'@formatjs/intl-listformat/locale-data/uk'),
  vi: () => import( /* webpackChunkName: 'locale-data-vi' */'@formatjs/intl-listformat/locale-data/vi'),
  zh: () => import( /* webpackChunkName: 'locale-data-zh' */'@formatjs/intl-listformat/locale-data/zh'),
  nb: () => import( /* webpackChunkName: 'locale-data-nb' */'@formatjs/intl-listformat/locale-data/nb')
};
//# sourceMappingURL=localeData.js.map